import axios from "axios";

export const makeRequest = axios.create({
  baseURL: "https://gestionale.hostsicilia.it:3003/server/",
  //baseURL: "http://localhost:3001/server/",
  withCredentials: true,
});